// Mugen Silver theme — nav, filters/sort, reveal animation, Shopify Ajax Cart

function initMobileNav() {
  var toggle = document.querySelector('.nav-toggle');
  var drawer = document.querySelector('.mobile-nav');
  var close = document.querySelector('.mobile-nav__close');
  if (!toggle || !drawer) return;
  var open = function () { drawer.classList.add('open'); toggle.setAttribute('aria-expanded', 'true'); };
  var shut = function () { drawer.classList.remove('open'); toggle.setAttribute('aria-expanded', 'false'); };
  toggle.addEventListener('click', open);
  if (close) close.addEventListener('click', shut);
  drawer.querySelectorAll('a').forEach(function (a) { a.addEventListener('click', shut); });
  document.addEventListener('keydown', function (e) { if (e.key === 'Escape') shut(); });
}

function initReveal() {
  var items = document.querySelectorAll('.reveal');
  if (!items.length) return;
  if (!('IntersectionObserver' in window)) {
    items.forEach(function (el) { el.classList.add('in'); });
    return;
  }
  var io = new IntersectionObserver(function (entries) {
    entries.forEach(function (entry) {
      if (entry.isIntersecting) {
        entry.target.classList.add('in');
        io.unobserve(entry.target);
      }
    });
  }, { threshold: 0.15 });
  items.forEach(function (el) { io.observe(el); });
}

function updateCartBadge() {
  fetch('/cart.js')
    .then(function (r) { return r.json(); })
    .then(function (cart) {
      var badge = document.querySelector('.cart-count');
      if (!badge) return;
      badge.textContent = String(cart.item_count);
      badge.style.display = cart.item_count > 0 ? 'flex' : 'none';
    });
}

function addToCartAjax(variantId, qty, btn) {
  var originalText = btn ? btn.textContent : null;
  fetch('/cart/add.js', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
    body: JSON.stringify({ id: variantId, quantity: qty || 1 })
  })
    .then(function (r) {
      if (!r.ok) throw new Error('Add to cart failed');
      return r.json();
    })
    .then(function () {
      updateCartBadge();
      if (btn) {
        btn.textContent = 'Added';
        setTimeout(function () { btn.textContent = originalText; }, 1200);
      }
    })
    .catch(function () {
      if (btn) btn.textContent = 'Error — try again';
    });
}

function initQuickAdd(root) {
  (root || document).querySelectorAll('.js-quick-add').forEach(function (btn) {
    btn.addEventListener('click', function () {
      var variantId = btn.dataset.variantId;
      if (!variantId) return;
      addToCartAjax(variantId, 1, btn);
    });
  });
}

// Enhance the real Shopify product form to submit via AJAX instead of a full page reload
function initProductFormAjax() {
  var form = document.querySelector('form[action^="/cart/add"]');
  if (!form) return;
  form.addEventListener('submit', function (e) {
    e.preventDefault();
    var btn = document.getElementById('add-to-cart-btn');
    var formData = new FormData(form);
    fetch('/cart/add.js', {
      method: 'POST',
      headers: { Accept: 'application/json' },
      body: formData
    })
      .then(function (r) {
        if (!r.ok) throw new Error('Add to cart failed');
        return r.json();
      })
      .then(function () {
        updateCartBadge();
        if (btn) {
          var original = btn.textContent;
          btn.textContent = 'Added to Cart';
          setTimeout(function () { btn.textContent = original; }, 1400);
        }
      })
      .catch(function () {
        if (btn) btn.textContent = 'Error — try again';
      });
  });
}

// Shop grid: client-side filter/sort over server-rendered product cards
function getSelectedValues(name) {
  return Array.from(document.querySelectorAll('input[name="' + name + '"]:checked')).map(function (el) { return el.value; });
}

function priceInRange(price, range) {
  var parts = range.split('-').map(Number);
  return price >= parts[0] && price <= parts[1];
}

function applyFiltersAndSort() {
  var grid = document.getElementById('shop-grid');
  if (!grid) return;

  var categories = getSelectedValues('category');
  var priceRanges = getSelectedValues('price');
  var sortEl = document.getElementById('sort-select');
  var sort = sortEl ? sortEl.value : 'featured';

  var cards = Array.from(grid.querySelectorAll('.product-card'));

  cards.forEach(function (card) {
    var cat = card.dataset.category;
    var price = parseFloat(card.dataset.price);
    var catOk = categories.length === 0 || categories.indexOf(cat) !== -1;
    var priceOk = priceRanges.length === 0 || priceRanges.some(function (r) { return priceInRange(price, r); });
    card.style.display = (catOk && priceOk) ? '' : 'none';
  });

  var visible = cards.filter(function (c) { return c.style.display !== 'none'; });

  switch (sort) {
    case 'price-asc':
      visible.sort(function (a, b) { return parseFloat(a.dataset.price) - parseFloat(b.dataset.price); });
      break;
    case 'price-desc':
      visible.sort(function (a, b) { return parseFloat(b.dataset.price) - parseFloat(a.dataset.price); });
      break;
    case 'name-asc':
      visible.sort(function (a, b) { return a.querySelector('.product-card__title').textContent.localeCompare(b.querySelector('.product-card__title').textContent); });
      break;
    case 'name-desc':
      visible.sort(function (a, b) { return b.querySelector('.product-card__title').textContent.localeCompare(a.querySelector('.product-card__title').textContent); });
      break;
    default:
      break;
  }

  visible.forEach(function (card) { grid.appendChild(card); });

  var count = document.getElementById('result-count');
  var empty = document.getElementById('empty-state');
  if (count) count.textContent = visible.length + (visible.length === 1 ? ' piece' : ' pieces');
  if (empty) empty.hidden = visible.length !== 0;
}

function initMobileFilters() {
  var filters = document.getElementById('filters');
  var openBtn = document.getElementById('filters-open');
  var closeBtn = document.getElementById('filters-close');
  var topBar = document.getElementById('filters-mobile-top');
  if (!filters || !openBtn) return;
  openBtn.addEventListener('click', function () {
    filters.classList.add('open');
    topBar.style.display = 'flex';
  });
  closeBtn.addEventListener('click', function () {
    filters.classList.remove('open');
    topBar.style.display = 'none';
  });
}

function initShopControls() {
  var filters = document.getElementById('filters');
  var sortEl = document.getElementById('sort-select');
  var resetBtn = document.getElementById('filter-reset');
  if (!filters) return;

  filters.addEventListener('change', applyFiltersAndSort);
  if (sortEl) sortEl.addEventListener('change', applyFiltersAndSort);
  if (resetBtn) {
    resetBtn.addEventListener('click', function () {
      filters.querySelectorAll('input[type="checkbox"]').forEach(function (cb) { cb.checked = false; });
      applyFiltersAndSort();
    });
  }
  initMobileFilters();
  applyFiltersAndSort();
}

function initNewsletterForm() {
  var form = document.getElementById('footer-newsletter-form');
  if (!form) return;
  // Shopify's customer form handles submission natively; nothing to intercept.
}

document.addEventListener('DOMContentLoaded', function () {
  initMobileNav();
  initReveal();
  updateCartBadge();
  initQuickAdd();
  initProductFormAjax();
  initShopControls();
  initNewsletterForm();
});
